import React from 'react';
import { SvgIcon } from '@mui/material';

const SortAscending = (props) => (
  <SvgIcon {...props}>
    <svg
      width="24px"
      height="24px"
      x="0px"
      y="0px"
      viewBox="-150 -150 1300 1300"
    >
      <g>
        <path d="M922.4,837.9H517.1c-37.2,0-67.6,30.3-67.6,67.6c0,37.2,30.3,67.6,67.6,67.6h405.4c37.4,0,67.6-30.3,67.6-67.6C990,868.1,959.8,837.9,922.4,837.9z M517.1,162.2h405.4c37.4,0,67.6-30.3,67.6-67.6c0-37.3-30.2-67.6-67.6-67.6H517.1c-37.2,0-67.6,30.3-67.6,67.6C449.5,131.9,479.8,162.2,517.1,162.2z M540.2,354.7c13.3-13.4,13.3-34.9,0-48.2L305.7,36.7c-7.1-7.1-16.4-10.1-25.6-9.7c-9.1-0.5-18.5,2.5-25.6,9.7L20,306.6c-13.4,13.3-13.4,34.7,0,48.2c13.1,13.3,24.2,10.2,24.2,10.2h202.7V973h67.6V364.9h202.7C517.1,364.9,527,368,540.2,354.7z M922.4,229.8H719.7c-37.2,0-67.6,30.3-67.6,67.6c0,37.2,30.3,67.6,67.6,67.6h202.7c37.4,0,67.6-30.3,67.6-67.6C990,260.1,959.8,229.8,922.4,229.8z M922.4,635.2H517.1c-37.2,0-67.6,30.3-67.6,67.6c0,37.2,30.3,67.6,67.6,67.6h405.4c37.4,0,67.6-30.3,67.6-67.6C990,665.5,959.8,635.2,922.4,635.2z M922.4,432.5H517.1c-37.2,0-67.6,30.3-67.6,67.6c0,37.2,30.3,67.6,67.6,67.6h405.4c37.4,0,67.6-30.3,67.6-67.6C990,462.8,959.8,432.5,922.4,432.5z" />
      </g>
    </svg>

  </SvgIcon>
);

export default SortAscending;
